import {
  STREAM_START_FAILED,
  STREAM_STOP_FAILED
} from '@shoflo/studio-redux/constants/StreamStates';

export function checkStreamStartFailedStatus(activeStreams) {
  return activeStreams?.some(stream => stream.status === STREAM_START_FAILED);
}

export function checkStreamStopFailedStatus(inActiveStreams) {
  return inActiveStreams?.some(stream => stream.status === STREAM_STOP_FAILED);
}

export function getStartStreamFailedIds(streamEndpoints) {
  return streamEndpoints
    ?.filter(stream => stream.status === STREAM_START_FAILED)
    .map(stream => stream._id);
}

export function getStopStreamFailedIds(streamEndpoints) {
  return streamEndpoints
    ?.filter(stream => stream.status === STREAM_STOP_FAILED)
    .map(stream => stream._id);
}
